import http from '../auth/httpService';

const apiEndpoint1 = '/projects';
let apiEndpoint2 = '/resolution';


// RESOLUCIONES

function projectResolutionUrl(projectSlug) {
  apiEndpoint2 = '/resolution';
  return `${apiEndpoint1}/${projectSlug}${apiEndpoint2}`;
}
export function getProjectResolution(projectSlug) {
  apiEndpoint2 = '/resolution';
  return http.get(projectResolutionUrl(projectSlug));
}
export function saveProjectResolution(project) {
  apiEndpoint2 = '/resolution';
  return http.post(apiEndpoint1 + apiEndpoint2, project.slug);
}
export function getProjectResolution1(projectSlug) {
  apiEndpoint2 = '/resolution';
  return http.get(projectResolutionUrl(projectSlug));
}
export function saveProjectResolution1(project) {
  apiEndpoint2 = '/resolution1';
  return http.post(apiEndpoint1 + apiEndpoint2, project.slug);
}
export function saveProjectResolution2(project) {
  apiEndpoint2 = '/resolution2';
  return http.post(apiEndpoint1 + apiEndpoint2, project.slug);
}
export function saveProjectResolution3(project) {
  apiEndpoint2 = '/resolution3';
  return http.post(apiEndpoint1 + apiEndpoint2, project.slug);
}
export function saveProjectResolution4(project) {
  apiEndpoint2 = '/resolution4';
  return http.post(apiEndpoint1 + apiEndpoint2, project.slug);
}
export function saveProjectResolution5(project) {
  apiEndpoint2 = '/resolution5';
  return http.post(apiEndpoint1 + apiEndpoint2, project.slug);
}
export function saveProjectResolution6(project) {
  apiEndpoint2 = '/resolution6';
  return http.post(apiEndpoint1 + apiEndpoint2, project.slug);
}
export function saveProjectResolution7(project) {
  apiEndpoint2 = '/resolution7';
  return http.post(apiEndpoint1 + apiEndpoint2, project.slug);
}
export function saveProjectResolution8(project) {
  apiEndpoint2 = '/resolution8';
  return http.post(apiEndpoint1 + apiEndpoint2, project.slug);
}
export function saveProjectResolution9(project) {
  apiEndpoint2 = '/resolution9';
  return http.post(apiEndpoint1 + apiEndpoint2, project.slug);
}
export function saveProjectResolution10(project) {
  apiEndpoint2 = '/resolution10';
  return http.post(apiEndpoint1 + apiEndpoint2, project.slug);
}


// INFORME SEMESTRAL ENERO - JUNIO

function projectInforme1Url(projectSlug) {
  apiEndpoint2 = '/informe1';
  return `${apiEndpoint1}/${projectSlug}${apiEndpoint2}`;
}
export function getProjectInforme1(projectSlug) {
  apiEndpoint2 = '/informe1';
  return http.get(projectInforme1Url(projectSlug));
}
export function saveProjectInforme1(project) {
  apiEndpoint2 = '/informe1';
  return http.post(apiEndpoint1 + apiEndpoint2, project.slug);
}
export function saveProjectInforme11(project) {
  apiEndpoint2 = '/informe11';
  return http.post(apiEndpoint1 + apiEndpoint2, project.slug);
}
export function saveProjectInforme12(project) {
  apiEndpoint2 = '/informe12';
  return http.post(apiEndpoint1 + apiEndpoint2, project.slug);
}
export function saveProjectInforme13(project) {
  apiEndpoint2 = '/informe13';
  return http.post(apiEndpoint1 + apiEndpoint2, project.slug);
}
export function saveProjectInforme14(project) {
  apiEndpoint2 = '/informe14';
  return http.post(apiEndpoint1 + apiEndpoint2, project.slug);
}
export function saveProjectInforme15(project) {
  apiEndpoint2 = '/informe15';
  return http.post(apiEndpoint1 + apiEndpoint2, project.slug);
}
export function saveProjectInforme16(project) {
  apiEndpoint2 = '/informe16';
  return http.post(apiEndpoint1 + apiEndpoint2, project.slug);
}
export function saveProjectInforme17(project) {
  apiEndpoint2 = '/informe17';
  return http.post(apiEndpoint1 + apiEndpoint2, project.slug);
}
export function saveProjectInforme18(project) {
  apiEndpoint2 = '/informe18';
  return http.post(apiEndpoint1 + apiEndpoint2, project.slug);
}
export function saveProjectInforme19(project) {
  apiEndpoint2 = '/informe19';
  return http.post(apiEndpoint1 + apiEndpoint2, project.slug);
}
export function saveProjectInforme110(project) {
  apiEndpoint2 = '/informe110';
  return http.post(apiEndpoint1 + apiEndpoint2, project.slug);
}


// INFORME SEMESTRAL JULIO - DICIEMBRE

function projectInforme2Url(projectSlug) {
  apiEndpoint2 = '/informe2';
  return `${apiEndpoint1}/${projectSlug}${apiEndpoint2}`;
}
export function getProjectInforme2(projectSlug) {
  apiEndpoint2 = '/informe2';
  return http.get(projectInforme2Url(projectSlug));
}
export function saveProjectInforme2(project) {
  apiEndpoint2 = '/informe2';
  return http.post(apiEndpoint1 + apiEndpoint2, project.slug);
}
export function saveProjectInforme21(project) {
  apiEndpoint2 = '/informe21';
  return http.post(apiEndpoint1 + apiEndpoint2, project.slug);
}
export function saveProjectInforme22(project) {
  apiEndpoint2 = '/informe22';
  return http.post(apiEndpoint1 + apiEndpoint2, project.slug);
}
export function saveProjectInforme23(project) {
  apiEndpoint2 = '/informe23';
  return http.post(apiEndpoint1 + apiEndpoint2, project.slug);
}
export function saveProjectInforme24(project) {
  apiEndpoint2 = '/informe24';
  return http.post(apiEndpoint1 + apiEndpoint2, project.slug);
}
export function saveProjectInforme25(project) {
  apiEndpoint2 = '/informe25';
  return http.post(apiEndpoint1 + apiEndpoint2, project.slug);
}
export function saveProjectInforme26(project) {
  apiEndpoint2 = '/informe26';
  return http.post(apiEndpoint1 + apiEndpoint2, project.slug);
}
export function saveProjectInforme27(project) {
  apiEndpoint2 = '/informe27';
  return http.post(apiEndpoint1 + apiEndpoint2, project.slug);
}
export function saveProjectInforme28(project) {
  apiEndpoint2 = '/informe28';
  return http.post(apiEndpoint1 + apiEndpoint2, project.slug);
}
export function saveProjectInforme29(project) {
  apiEndpoint2 = '/informe29';
  return http.post(apiEndpoint1 + apiEndpoint2, project.slug);
}
export function saveProjectInforme210(project) {
  apiEndpoint2 = '/informe210';
  return http.post(apiEndpoint1 + apiEndpoint2, project.slug);
}


// ACTA DE CEIRRE


function projectCierreUrl(projectSlug) {
  apiEndpoint2 = '/cierre';
  return `${apiEndpoint1}/${projectSlug}${apiEndpoint2}`;
}

export function getProjectCierre(projectSlug) {
  apiEndpoint2 = '/cierre';
  return http.get(projectCierreUrl(projectSlug));
}

export function saveProjectCierre(project) {
  apiEndpoint2 = '/cierre';
  return http.post(apiEndpoint1 + apiEndpoint2, project.slug);
}


